declare namespace $ {

	type $mol_select__Filter_shm_hitalama_map_widget_float_settings_tabulator_1 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_settings_tabulator_2 = $mol_type_enforce<
		({ 
			'fitDataStretch': string,
			'fitColumns': string,
			'fitData': string,
			'fitDataFill': string,
			'fitDataTable': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_settings_tabulator_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_tabulator['layout'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_settings_tabulator_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_settings_tabulator_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_tabulator['Layout'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_settings_tabulator_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_settings_tabulator_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_tabulator['sortable'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_settings_tabulator_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_settings_tabulator_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_tabulator['header_filter'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_settings_tabulator_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_settings_tabulator_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_tabulator['resizable_columns'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_settings_tabulator_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_settings_tabulator_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_tabulator['movable_columns'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_settings_tabulator_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_settings_tabulator_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_tabulator['editable'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_settings_tabulator_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_settings_tabulator_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_tabulator['pagination'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_float_settings_tabulator_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_tabulator['page_size'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__precision_shm_hitalama_map_widget_float_settings_tabulator_19 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['precision'] >
	>
	type $mol_number__precision_change_shm_hitalama_map_widget_float_settings_tabulator_20 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['precision_change'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_settings_tabulator_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_settings_tabulator_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_tabulator['Page_size'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_textarea__hint_shm_hitalama_map_widget_float_settings_tabulator_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_settings_tabulator_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_tabulator['headers_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__spellcheck_shm_hitalama_map_widget_float_settings_tabulator_25 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['spellcheck'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_settings_tabulator_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_settings_tabulator_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_tabulator['Headers'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_textarea__hint_shm_hitalama_map_widget_float_settings_tabulator_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__sidebar_showed_shm_hitalama_map_widget_float_settings_tabulator_29 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['sidebar_showed'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_settings_tabulator_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_tabulator['head_code'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__spellcheck_shm_hitalama_map_widget_float_settings_tabulator_31 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['spellcheck'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_settings_tabulator_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_settings_tabulator_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_tabulator['Head_code'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_textarea__hint_shm_hitalama_map_widget_float_settings_tabulator_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__sidebar_showed_shm_hitalama_map_widget_float_settings_tabulator_35 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['sidebar_showed'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_settings_tabulator_36 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_tabulator['rows_code'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__spellcheck_shm_hitalama_map_widget_float_settings_tabulator_37 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['spellcheck'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_settings_tabulator_38 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_settings_tabulator_39 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_tabulator['Rows_code'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	export class $shm_hitalama_map_widget_float_settings_tabulator extends $shm_hitalama_map_widget_float_settings {
		layout( next?: string ): string
		Layout( ): $mol_select
		Layout_field( ): $mol_form_field
		sortable( next?: boolean ): boolean
		Sortable( ): $mol_check_box
		header_filter( next?: boolean ): boolean
		Header_filter( ): $mol_check_box
		resizable_columns( next?: boolean ): boolean
		Resizable_columns( ): $mol_check_box
		movable_columns( next?: boolean ): boolean
		Movable_columns( ): $mol_check_box
		editable( next?: boolean ): boolean
		Editable( ): $mol_check_box
		pagination( next?: boolean ): boolean
		Pagination( ): $mol_check_box
		page_size( next?: number ): number
		Page_size( ): $mol_number
		Page_size_field( ): $mol_form_field
		pagination_settings( ): readonly(any)[]
		headers_text( next?: string ): string
		Headers( ): $mol_textarea
		Headers_label( ): $mol_labeler
		head_code( next?: string ): string
		Head_code( ): $mol_textarea
		Head_code_label( ): $mol_labeler
		rows_code( next?: string ): string
		Rows_code( ): $mol_textarea
		Rows_code_label( ): $mol_labeler
		controls( ): readonly(any)[]
		controlled_settings_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=tabulator.view.tree.d.ts.map